module.exports = __webpack_public_path__ + "static/media/img_sidebar_logo.d5f5b975.svg";